// extracted by mini-css-extract-plugin
module.exports = {"bannerList":"index-module_bannerList_1ha2F"};